import {expectEither, HttpClient, POST} from '@raison/network-facade';
import {AccountId, TransactionIdIoTs} from '@raison/types';
import {string, type} from 'io-ts';
import {CryptoCurrencyType} from '~/entities/currencies';
import {BlockchainInfo, signCryptoTransaction, TransactionHolder} from '~/entities/operations-crypto';

export async function submitUsualSignedSendTransaction(
    http: HttpClient,
    data: {
        holder: TransactionHolder;
        wallet: {
            id: AccountId;
            type: CryptoCurrencyType;
            blockchain: BlockchainInfo;
        };
        codeFromSms: string;
    }
) {
    const cypherResult = await signCryptoTransaction(http, data);
    if (cypherResult.status !== 'Ok') {
        return cypherResult;
    }
    const signature = cypherResult.datum;

    const walletId = data.wallet.id;
    const url = (() => {
        switch (data.wallet.type) {
            case 'crypto':
                return `v1/wallets/${walletId}/send`;
            case 'stablecoin':
                return `v1/tokens/${walletId}/send`;
        }
    })();

    const response = await http(url, POST(signature)).then(
        ...expectEither({
            200: type({id: TransactionIdIoTs}),
            201: type({id: TransactionIdIoTs}),
            400: type({message: string}),
        })
    );
    if (response.status === 'Abort') {
        return response;
    }
    if (response.status === 400) {
        return {status: 'BadRequest', datum: response.json.message} as const;
    }

    return {status: 'Ok', datum: {id: response.json.id}} as const;
}
